const config = {
  API_URL: process.env.REACT_APP_API,
  APP_TYPE: process.env.REACT_APP_TYPE,
  HELLOSIGN_CLIENT_ID: process.env.REACT_APP_HELLOSIGN_CLIENT_ID,
  USER_INACTIVE: process.env.REACT_APP_USER_INACTIVE_TIMEOUT || 170400000,
  SOCKET_API_ENDPOINT: process.env.REACT_APP_API,
};

export default config;
